let iosSwitch: HTMLLabelElement | null = null;

// iOS Safari has no Vibration API, but toggling a native switch control (Safari 18+) plays the system tick.
function iosTick() {
  if (!iosSwitch) {
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.id = 'inbox-haptic-switch';
    input.setAttribute('switch', '');
    input.tabIndex = -1;
    input.setAttribute('aria-hidden', 'true');
    const label = document.createElement('label');
    label.htmlFor = input.id;
    label.setAttribute('aria-hidden', 'true');
    label.style.cssText = 'position:fixed;width:0;height:0;overflow:hidden;opacity:0;pointer-events:none;';
    label.appendChild(input);
    document.body.appendChild(label);
    iosSwitch = label;
  }
  iosSwitch.click();
}

export function haptic(kind: 'tick' | 'success' = 'tick') {
  if (typeof window === 'undefined' || !window.matchMedia('(pointer: coarse)').matches) return;
  if (typeof navigator.vibrate === 'function') {
    navigator.vibrate(kind === 'success' ? [10, 60, 14] : 8);
    return;
  }
  iosTick();
}
